import { useState, useEffect, useCallback } from 'react';
import { path, split, pipe, defaultTo } from 'ramda';

const getNestedValue = pipe(
    defaultTo(''),
    split('.'),
    path,
);

const useWindowObjectObserver = (dotPath) => {
    const getValue = useCallback(() => {
        if (typeof window === 'undefined') {
            return undefined;
        }
        return getNestedValue(dotPath)(window);
    }, [dotPath]);

    const [value, setValue] = useState(getValue);

    useEffect(() => {
        const checkValue = () => {
            setValue(getValue());
        };

        checkValue(); // Initial check

        const observer = new MutationObserver(checkValue);
        observer.observe(document, { childList: true, subtree: true });

        window.addEventListener('load', checkValue);

        return () => {
            observer.disconnect();
            window.removeEventListener('load', checkValue);
        };
    }, [dotPath, getValue]);

    return value;
};

export default useWindowObjectObserver;
